import { Component } from 'react';
import autoBind from 'react-autobind';
import classNames from 'classnames/bind';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons/faTrashAlt';
import { faPencil } from '@fortawesome/pro-light-svg-icons/faPencil';
import { faMoneyCheckPen } from '@fortawesome/pro-light-svg-icons/faMoneyCheckPen';
import { faBriefcase } from '@fortawesome/pro-solid-svg-icons/faBriefcase';
import { faClose } from '@fortawesome/pro-light-svg-icons/faClose';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { Link } from 'react-router-dom';

import * as watchlistActions from '../../../actions/watchlistActions';
import * as searchActions from '../../../actions/searchActions';

import { checkDuplicates } from '../../../helpers/watchlistHelperFunctions';

import withComponentName from '../../../decorators/withComponentName';

import RemoveAllWatchlistsModal from '../../Modals/RemoveAllWatchlistsModal';
import RenameWatchlistModal from '../../Modals/RenameWatchlistModal';
import Tooltip from '../../Tooltip';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

class WatchlistControls extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      personalisationExpand: false,
      openTopics: false,
      showInput: false,
      newName: '',
      openRemoveWLModal: false,
      openRenameWLModal: false,
      errors: '',
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  componentDidUpdate(prevProps) {
    const { dropDownOpen, onExpandChange } = this.props;

    if (dropDownOpen !== prevProps.dropDownOpen) {
      onExpandChange('personalisationExpand', false);
      onExpandChange('openTopics', false);
    }
  }

  handleCloseWLRemoveModal() {
    this.setState({
      openRemoveWLModal: false,
    });
  }

  handleOpenWLRemoveModal() {
    this.setState({
      openRemoveWLModal: true,
    });
  }

  handleCloseWLRenameModal() {
    this.setState({
      openRenameWLModal: false,
    });
  }

  handleOpenWLRenameModal() {
    this.setState({
      openRenameWLModal: true,
    });
  }

  onChangeWatchlistName(e) {
    const { value: newWatchlistName } = e.target;
    this.setState({ newName: newWatchlistName });
  }

  validateWatchlistName(newName) {
    if (!newName) {
      this.setState({ errors: 'Name is required' });
      return true;
    }
    this.setState({ errors: '' });
  }

  watchlistNameFormSubmit(e, id) {
    e.preventDefault();
    const {
      actions,
      token,
      watchlists,
      activeWatchlist,
      piwikEnabled,
    } = this.props;
    const { newName } = this.state;

    const errors = this.validateWatchlistName(newName);

    if (errors) return;

    const nameNotChanged = activeWatchlist.name === newName;

    if (nameNotChanged) {
      this.toggleInput();
      return;
    }

    const isHaveDuplicates = checkDuplicates(watchlists, newName);

    if (isHaveDuplicates) {
      this.handleOpenWLRenameModal();
    } else {
      if (token) {
        actions.editWatchlistName(id, newName, activeWatchlist.id);
      } else {
        actions.editGuestUserWatchlistName(id, newName);
      }
      if (piwikEnabled) _paq.push(['trackEvent', 'WL page', 'Rename WL']);

      this.toggleInput();
    }
  }

  toggleTopicsOpen() {
    const { onExpandChange } = this.props;
    const { openTopics } = this.state;

    onExpandChange('personalisationExpand', false);
    onExpandChange('openTopics', !openTopics);
  }

  toggleInput() {
    const { activeWatchlist: { name } } = this.props;

    this.setState(({ showInput }) => ({
      showInput: !showInput,
      newName: name,
    }));
  }

  render() {
    const {
      actions,
      width,
      activeWatchlist,
      watchlists,
      activeWatchlist: { name, id },
      activateFilingsPreloader,
      activeWatchlistTopics,
      piwikEnabled,
      hasBigScreenDesign,
    } = this.props;
    const {
      newName,
      showInput,
      openTopics,
      personalisationExpand,
      errors,
      openRemoveWLModal,
      openRenameWLModal,
    } = this.state;

    const watchlistNameClass = cx({
      watchlist_name_container: true,
      active: showInput,
      big_screen: hasBigScreenDesign,
    });
    const noTopic = !activateFilingsPreloader && !activeWatchlistTopics.length
      && !(personalisationExpand || openTopics);

    const getWlName = () => {
      if (width > 767) {
        return (name?.length > 30 ? `${name.slice(0, 30)}...` : name);
      }
      return (name?.length > 20 ? `${name.slice(0, 20)}...` : name);
    };

    return (
      <div className={cx('mobile_watchlist_controls')}>
        <div className={watchlistNameClass}>
          <div className={`${Styles.watchlist_name_inner} d-flex align-items-center`}>
            {showInput ? (
              <form
                onSubmit={(e) => this.watchlistNameFormSubmit(e, id)}
                className={cx('change_name_input', { hasErrors: errors })}
              >
                <input
                  type="text"
                  value={newName}
                  onChange={this.onChangeWatchlistName}
                />
                <button type="submit" className={cx('change_name_submit', { hasErrors: errors })}>
                  <FontAwesomeIcon icon={faCheck} />
                </button>
                <button type="button" onClick={this.toggleInput} className={cx('change_name_cancel')}>
                  <FontAwesomeIcon icon={faClose} />
                </button>
                {errors && <span className={cx('error_message')}>{errors}</span>}
              </form>
            ) : (
              <div
                className={Styles.name}
                onClick={actions.openNewWatchlistDropDown}
              >
                <p className="active-watchlist-name">{getWlName()}</p>
              </div>
            )}
            <div className={cx('watchlist_controls', { '--width': showInput })}>
              <div className={Styles.watchlist_controls_wrapper}>
                <div
                  className={Styles.delete}
                  onClick={this.handleOpenWLRemoveModal}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </div>
                <div className={Styles.edit} onClick={this.toggleInput}>
                  <FontAwesomeIcon icon={faPencil} />
                </div>
              </div>
            </div>
          </div>
          {!!watchlists?.length && (
            <Tooltip
              className={Styles.manage_tooltip}
              icon={(
                <Link className={Styles.manage} to="/watchlists/manage">
                  <FontAwesomeIcon icon={faMoneyCheckPen} />
                </Link>
              )}
              hasBigScreenDesign
              isBigScreen
            >
              Manage Watchlists
            </Tooltip>
          )}
        </div>
        <div className="d-flex align-items-center">
          <div
            className={cx('watchlist_controls_button', 'topics', { expanded: openTopics, no_topic: noTopic })}
            onClick={() => this.toggleTopicsOpen()}
          >
            <FontAwesomeIcon icon={faBriefcase} />
            <span className={cx('watchlist_controls_button_content')}>Topics</span>
          </div>
        </div>
        <RemoveAllWatchlistsModal
          openModal={openRemoveWLModal}
          handleCloseModal={this.handleCloseWLRemoveModal}
          watchlistName={name}
          id={id}
          removeOnlyOneWatchlist
        />
        <RenameWatchlistModal
          openModal={openRenameWLModal}
          handleCloseModal={this.handleCloseWLRenameModal}
          watchlistsArray={watchlists}
          id={id}
          newName={newName}
          activeWatchlist={activeWatchlist}
          closeInput={this.toggleInput}
          piwikEnabled={piwikEnabled}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...watchlistActions, ...searchActions }, dispatch),
});

const mapStateToProps = (state) => ({
  activeWatchlist: state.watchlistReducer.activeWatchlist,
  storyFilters: state.storyFilters,
  watchlists: state.watchlistReducer.watchlistsList,
  watchlistLoading: state.watchlistReducer.watchlistPageLoad,
  dropDownOpen: state.watchlistReducer.newWatchlistDropDown,
  accessLevels: state.subscriptions.permissions.access_levels,
  activateFilingsPreloader: state.watchlistReducer.activateFilingsPreloader,
  activeWatchlistTopics: state.watchlistReducer.activeWatchlistTopics,
  token: state.watchlistReducer.userToken,
});

export default withComponentName(
  connect(mapStateToProps, mapDispatchToProps)(WatchlistControls),
);
